import { FaExternalLinkAlt } from "react-icons/fa";
import { imageUrlFor } from "../../../lib/image-url";
import BlockText from "../../block-content/block-text";

const ExternalCallOuts = ({pageBlockGroup: { title, _rawBody, externalCallOuts }}) => {
    return <section className="py-10 md:py-16 bg-gradient">
        <div className="max-w-7xl mx-auto px-4">
            <div className="w-full md:w-8/12 mx-auto">
                {title &&
                    <>
                        <hr className="w-8 border-yellow-500 border-4 mb-2" />
                        <h2 className="text-blue-500 leading-tight font-bold tracking-tighter text-2xl md:text-3xl mb-1 md:mb-3">{title}</h2>
                    </>
                }
                {_rawBody &&
                    <BlockText blocks={_rawBody} />
                }
            </div>
            <ul className={`md:flex md:flex-wrap md:-mx-2 ${externalCallOuts?.length < 3 ? 'justify-center' : ''}`}>
                {externalCallOuts?.map(({ title, _rawBody, externalLink, linkLabel, image, _key }, index) =>
                    <li key={_key} className="w-full lg:flex lg:flex-col md:mb-4 md:w-1/2 md:px-2 lg:w-4/12">
                        <a href={externalLink} className="flex flex-col flex-1 bg-white shadow-lg rounded mb-6 md:mb-0">
                            <div className="p-4 lg:p-6 flex-1">
                                {image?.asset?._id &&
                                    <div className="mb-4">
                                        <img loading="lazy" style={{maxHeight: 96}} src={imageUrlFor(image.asset._id).auto("format").height(192).quality(60).url()} alt={image.asset.altText || ''} />
                                    </div>
                                }
                                {title &&
                                    <h2 className="text-blue-500 tracking-tight uppercase font-bold mb-1">{title}</h2>
                                }
                                {_rawBody &&
                                    <div className="mb-6 flex-grow">
                                        <BlockText blocks={_rawBody} isPlain={true} />
                                    </div>
                                }
                                {linkLabel &&
                                    <p className="text-xs md:text-sm px-3 py-3 text-center inset-x-0 bottom-0 bg-blue-500 text-white font-bold md:tracking-wide rounded-b md:rounded uppercase flex justify-center items-center group-hover:bg-blue-700">
                                        {linkLabel}
                                        <FaExternalLinkAlt className="fill-current ml-2 w-4 h-4 -mt-1" />
                                    </p>
                                }
                            </div>
                        </a>
                    </li>
                )}
            </ul>
        </div>
    </section>
};

export default ExternalCallOuts;